import Box from "@mui/material/Box";
import React from "react";
import Signup from "./Signup";
import SignupToolbar from "./SignupToolbar";

/**
 * Container component for the signup page
 * Manages language switching and provides the signup toolbar
 * Theme, QueryClient, and other providers are inherited from the main App
 * Language detection and persistence is handled by i18n.js
 */
const SignupContainer = () => {
    return (
        <Box sx={{ 
            minHeight: "100vh",
            backgroundColor: "background.default",
            color: "text.primary"
        }}>
            <SignupToolbar />
            <Signup />
        </Box>
    );
};

export default SignupContainer;

